/** @file adler32: the zlib stream checksum (RFC 1950). */

const MOD = 65521;
/** Largest run of bytes before `b` can overflow 2^32 between reductions (zlib's NMAX). */
const NMAX = 5552;

/** Unsigned Adler-32 of `bytes` (1 for no bytes). */
export function adler32(bytes: Uint8Array): number {
  let a = 1;
  let b = 0;
  for (let start = 0; start < bytes.length; start += NMAX) {
    const end = Math.min(bytes.length, start + NMAX);
    for (let i = start; i < end; i++) {
      a += bytes[i] ?? 0;
      b += a;
    }
    a %= MOD;
    b %= MOD;
  }
  return ((b << 16) | a) >>> 0;
}
